<template>
  <div class="text-center">
    <v-dialog persistent v-model="visible" width="1200">
      <v-card class="not-margin pt-0 pr-0 pl-0">
        <v-toolbar dark color="primary">
          <div class="text-center">
            Listagem de Participantes
          </div>
        </v-toolbar>
        <div class="container dialog mt-4">
          <h3>
            Listagem de Participantes
          </h3>
          <v-row class="justify-center">
            <v-data-table
                class="mt-5"
                :headers="headers"
                :items="lists.formacoes"
                :items-per-page="10"
                :footer-props="$footerProps"
                show-expand
                style="min-width: 1000px;"
            >
              <template v-slot:expanded-item="{ item }">
                <td :colspan="headers.length">
                  <div >
                    <div v-if="item.participantes?.length > 0" class="mb-2">
                      <strong>Participante</strong>
                      <v-simple-table dense>
                        <tbody>
                          <tr v-for="(participante, i) in item.participantes" :key="'p-' + i">
                            <td>{{ participante.nome }}</td>
                          </tr>
                        </tbody>
                      </v-simple-table>
                    </div>

                    <div v-if="item.escolas?.length > 0">
                      <strong>Escola</strong>
                      <v-simple-table dense>
                        <tbody>
                          <tr v-for="(escola, i) in item.escolas" :key="'e-' + i">
                            <td>{{ escola.nome }}</td>
                          </tr>
                        </tbody>
                      </v-simple-table>
                    </div>
                  </div>
                </td>
              </template>
            </v-data-table>
          </v-row>
        </div>
        <v-row  class="d-flex justify-center total-participantes">
          <p>Total Geral de Participantes: {{totalParticipantes}}</p>
        </v-row>
        <v-row  class="d-flex justify-center mt-6 mb-4" style="gap:2rem;">
          <v-btn outlined color="primary" @click="$emit('onClose')">Voltar</v-btn>
          <v-btn color="primary" class="mr-3" @click="baixarRelatorioPdf">Exportar</v-btn>
        </v-row>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import { DialogProps } from '~/commons/classes/dialog-props';
import {Dashboard} from "commons/classes/dashboard";
import DashboardFormacaoService from "services/dashboard-formacao.service";

export default {
  props: new DialogProps(Dashboard),
  mixins: [DashboardFormacaoService],
  data: () => ({
    lists: {
      formacoes: [],
    },
    headers: [
      { text: "Formação", align: "center", value: "formacao" },
      { text: "GRE", align: "center", value: "vweoNome" },
      { text: "Participante/Escola", align: "center", value: "data-table-expand" },
      { text: "Total Participantes", align: "center", value: "totalParticipantes"},
    ],
  }),
  methods: {
    getFormacoes() {
      this.$buscarDashboardParticipantes({ params: {GreCodigo: this.content.id, OrigemId: this.content?.origemId}}).then(
          ({ data }) => this.lists.formacoes= data.lista
      )
    },
    async baixarRelatorioPdf() {
      this.showPageLoading();
      try {
        const { data } = await this.$buscarDashboardParticipantesPdf(this.$montarParamsFilters(
            {GreCodigo: this.content.id, OrigemId: this.content?.origemId}));
        const url = URL.createObjectURL(data);
        const link = document.createElement("a");
        link.href = url;
        link.setAttribute("download", "SIGFOCO.ListaDeParticipantesEscola.pdf");
        document.body.appendChild(link);
        link.click();
        this.$notifySuccess("Operação realizada com sucesso.");
      } finally {
        this.hidePageLoading();
      }
    },
  },
  computed: {
    totalParticipantes() {
      return this.lists.formacoes.reduce((total, formacao) => total + formacao.totalParticipantes, 0);
    }
  },
  mounted() {
    this.getFormacoes();
  },
}
</script>

<style lang="scss" scoped>

.total-participantes {
  font-size: 0.8rem;
  margin-top: -2.7rem;
  margin-left: -20rem;
}

</style>